<template>
  <div>
    <div v-if="loading" class="d-flex align-center justify-center" style="height: calc(100vh - 64px - 48px)">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <div v-else class="pa-4">
      <template v-if="orderList.length>0">
        <div v-if="!fastFoodMode" class="text-subtitle-1 font-weight-bold">
          {{ $t("Ordered") }}
        </div>
        <template v-else>
          <div class="d-flex align-center justify-center">
            <div>
              <div class="text-body-1 font-weight-black">
                # {{ orderInfo.dailySerial || orderInfo.tableName }} / {{orderInfo?.id}}
              </div>
              <div class="text-body-2">
                {{ $t("AfterPaymentOrderPreparedHint") }}
              </div>
            </div>
            <v-spacer></v-spacer>
          </div>

        </template>

        <div class="pb-16 mt-4">
          <div v-for="user in Object.keys(groupOrderList)" :key="user">
            <div class="text-body-2 px-4 py-2">
              {{ user }}
              <template v-if="user===userStore.userName">({{ $t("me") }})</template>
            </div>
            <v-card
              v-for="dish in groupOrderList[user]"
              :key="dish.id"
              class="pa-2 mb-3 d-flex align-center"
              elevation="0"
              style="border-radius: 12px;"
            >
              <div class="text-body-2 amber--text text--lighten-3 font-weight-black ml-2" style="min-width: 36px">
                {{ dish.count }}&times;
              </div>
              <div class="pa-1 black" style="border-radius: 8px;height: min-content">
                <dish-image
                  :cloud-image="dish.cloudImage" :image="dish.image" :image-root="GlobalConfig.imageRoot" :width="36"
                />
              </div>

              <div class="flex-grow-1 ml-3">
                <div class="font-weight-medium text-body-2">{{ dish.name }}</div>
                <div v-if="dish.displayApply.length>0" class="text-body-2 text--secondary mt-1">
                  {{ dish.displayApply.map(it => it.value).join(", ") }}
                </div>


              </div>

              <div class="pa-2">

                <div class="mt-1 text-no-wrap text-body-2 text--secondary">
                  {{ dish.realPrice | priceDisplay }}
                </div>

              </div>

            </v-card>
          </div>
          <div class="d-flex flex-column mt-12" style="width: 100%">
            <div v-if="fastFoodMode" class="text-body-1">
              <div v-if="!isTakeaway">
                {{ $t("ScanCodeDineIn") }}
              </div>
              <div v-else>
                {{ $t("PickAndTakeAway") }}
              </div>
            </div>
            <div class="text-body-2 text--secondary font-weight-medium">{{ $t("Total") }}</div>
            <div class="mt-2 text-h4 font-weight-bold">
              {{ totalPriceOrderedDish | priceDisplay }}
            </div>
            <div class="text-caption text--secondary mt-2">{{ $t("IncludeVat") }}</div>
          </div>

        </div>
      </template>
      <template v-else>
        <div class="d-flex flex-column align-center justify-center" style="height: calc(100vh - 64px - 48px);">
          <v-icon x-large>mdi-noodles</v-icon>
          <div class="text-body-1 mt-8">
            {{ $t("YouNotOrderedDishes") }}
          </div>
          <v-btn color="primary black--text mt-2" @click="$router.push('/menu')">
            {{ $t("OrderNow") }}
          </v-btn>
        </div>
      </template>

    </div>
    <v-card
      v-if="orderList.length>0&&!fastFoodMode"
      :style="fastFoodMode?'bottom:0px':'bottom:60px'"
      class="pa-4 d-flex" style="position: fixed;left: 0;right: 0;" tile
    >
      <div class=" d-flex align-center">
        <v-icon class="mr-2" size="18">mdi-format-list-bulleted-square</v-icon>
        <div class="text-body-1 font-weight-medium">
          {{ totalPriceOrderedDish | priceDisplay }}
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="showCheckoutButton === '1'" color="primary black--text" rounded
        @click="EBonStatus ? showReviewPage = true : showPaymentSelect = true"
      >
        {{ $t("Checkout") }}
      </v-btn>
    </v-card>
    <v-card
      v-if="fastFoodMode"
      class="rounded-t-xl pa-4"
      color="black"
      style="display: grid;grid-gap: 24px;grid-template-columns: repeat(2,minmax(0,1fr));position: fixed;right: 0;left: 0;bottom: 0;z-index: 100"
    >
      <v-card
        :color="'grey darken-4'"
        class="d-flex justify-center align-center pa-4"
        rounded="xl"
        @click="$router.replace('/menu')"
      >
        <v-icon class="mr-2">mdi-arrow-left</v-icon>
      </v-card>
      <v-card
        :color="'grey darken-4'"
        class="d-flex justify-center align-center pa-4"
        rounded="xl"
        @click="showFastFoodPaymentPage=true"
      >
        <v-icon>mdi-wallet</v-icon>
      </v-card>
    </v-card>
    <v-bottom-sheet v-model="showReviewPage">
      <v-list color="black">
        <v-subheader>{{ $t("Total") }}</v-subheader>
        <v-list-item>
          <v-list-item-title>
            {{ totalPriceOrderedDish | priceDisplay }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            <div class="text--secondary"> {{ $t("wannaUseEBon") }}</div>
            <div class="text-caption"> {{ $t("useEBonSaveALot") }}</div>
          </v-list-item-title>
        </v-list-item>
        <template v-if="!checkEmail">
          <v-list-item>
            <v-btn class="mt-2" color="primary black--text" width="100%" @click="checkOrderInfo">
              <v-icon left>mdi-check</v-icon>
              {{ $t("yes") }}
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn class="my-2" color="grey lighten-5 black--text" width="100%" @click="notUseEBon">
              <v-icon left>mdi-close</v-icon>
              {{ $t("no") }}
            </v-btn>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item>
            <v-text-field v-model="email" :label="$t('inputEmail')"></v-text-field>
          </v-list-item>
          <v-list-item>
            <div class="d-flex" style="width: 100%">
              <v-btn class="my-2 mr-2" color="grey lighten-5 black--text" @click="notUseEBon">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn :loading="btnLoading" class="my-2 flex-grow-1" color="primary black--text" @click="sendEmail">
                <v-icon left>mdi-email-fast-outline</v-icon>
                {{ $t("sendEmail") }}
              </v-btn>
            </div>
          </v-list-item>
        </template>
      </v-list>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="showTipPage">
      <v-list color="black">
        <v-subheader>{{ $t("Total") }}</v-subheader>
        <v-list-item>
          <v-list-item-title>
            {{ totalPriceOrderedDish | priceDisplay }}
          </v-list-item-title>
        </v-list-item>
        <v-subheader>{{ $t("GiveTip") }}?</v-subheader>
        <v-list-item
          v-for="p in tipPercentage"
          :key="p"
          @click="submitTip(p)"
        >
          <v-list-item-avatar>
            <v-icon>mdi-face-man-shimmer</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>+ {{ p }}%</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action-text style="white-space: nowrap">{{ totalPriceOrderedDish * p * 0.01 | priceDisplay }}
          </v-list-item-action-text>
        </v-list-item>
        <v-list-item @click="submitTip(0)">
          <v-list-item-avatar>
            <v-icon>mdi-emoticon-wink-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>{{ $t("NoThanks") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="showCommentPage">
      <v-list color="black">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("ThanksForReview") }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t("ReviewHint") }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-textarea :label="$t('ReviewLabel')" :placeholder="$t('ReviewPlaceHolder') + '😀'"></v-textarea>
        </v-list-item>
        <v-list-item>
          <v-btn block color="primary black--text" @click="submitComment">
            {{ $t("Submit") }}
          </v-btn>
        </v-list-item>


      </v-list>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="showPaymentSelect">
      <v-list color="black">
        <v-subheader>{{ $t("Total") }}</v-subheader>
        <v-list-item>
          <v-list-item-title>
            {{ totalPriceOrderedDish | priceDisplay }}
          </v-list-item-title>
          <v-list-item-action-text v-if="tipAmount>0" style="white-space: nowrap">
            + {{ tipAmount | priceDisplay }} {{ $t("Top") }}
          </v-list-item-action-text>

        </v-list-item>
        <v-subheader>{{ $t("PaymentMethod") }}</v-subheader>
        <v-list-item @click="payByMethod(2)">
          <v-list-item-avatar>
            <v-icon>mdi-credit-card</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>{{ $t("CreditCard") }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="payByMethod(1)">
          <v-list-item-avatar>
            <v-icon>mdi-cash</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>{{ $t("Bar") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="showCompletePage" fullscreen persistent>
      <v-card tile>
        <order-complete @return="showCompletePage=false"/>
      </v-card>

    </v-bottom-sheet>
    <v-bottom-sheet v-if="fastFoodMode" v-model="showFastFoodPaymentPage">
      <v-card class=" rounded-t-lg pa-4 py-6" color="black">
        <div class="">
          <div class="text-body-1 font-weight-black amber--text text--lighten-3">
            {{ $t("Checkout") }}
          </div>
          <div class="text-body-2 mt-1">
            {{ $t("AfterPaymentOrderPreparedHint") }}
          </div>
        </div>

        <div class="text-center text-h1 mt-12 py-12 grey darken-4 rounded-lg" style="width: 100%">
          <div class="font-weight-black">
            {{ orderInfo.dailySerial || orderInfo?.tableName?.toLowerCase()?.replace("w", "") }}
          </div>
        </div>

        <!-- PayPal Button Container -->
        <div v-if="paypalApiKey" class="mt-6">
          <div class="text-body-2 mb-2">{{ $t("PayWithPayPal") }}</div>
          <div ref="paypalButtonContainer" class="mb-4"></div>
        </div>

        <v-btn class="mt-6" color="grey lighten-4 black--text" @click="showFastFoodPaymentPage=false">{{
            $t("Close")
          }}
        </v-btn>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import {DishDocker} from "aaden-base-model";
import {
  checkElectronicBillingStatus,
  dishesInTable,
  forceGetSystemSetting,
  getCurrentInfo,
  getImageCache, getOrderInfo,
  getOrderStatus,
  notifyCheckout,
  requireCheckOut,
  sendMailTo
} from "@/dataLayer/service/api";
import {getCurrentRestaurantInfo} from "@/dataLayer/repository/restaurantInfo";
import DishImage from "@/views/components/DishImage.vue";
import {GlobalConfig, setTableName} from "@/dataLayer/repository/GlobalSettingManager";
import OrderComplete from "@/views/pages/OrderComplete.vue";
import {groupBy, keyBy} from "lodash-es";
import {mapStores} from "pinia";
import {useUserStore} from "@/dataLayer/userStore";
import {usePaymentStore} from "@/dataLayer/paymentStore";
import {Remember} from "@/plugins/firebase";
import IKUtils from "innerken-js-utils";
import router from "@/plugins/router";
import {loadScript} from '@paypal/paypal-js';
import {useCartStore} from "@/dataLayer/service/CartService";
import {rotateDailySerial} from "@/dataLayer/service/OrderService";

const OrderedDishFactory = DishDocker.StandardDishesListFactory();
export default {
  name: "OrderPage",
  components: {OrderComplete, DishImage},
  data: function () {
    return {
      showFastFoodPaymentPage: false,
      modeSelected: Remember.modeSelected === 1,
      isTakeaway: Remember.isTakeaway === 1,
      fastFoodMode: !IKUtils.getQueryString("tableName"),
      showCheckoutButton: "",
      btnLoading: false,
      EBonStatus: false,
      orderInfo: [],
      email: "",
      checkEmail: false,
      orderedDish: OrderedDishFactory,
      GlobalConfig,
      loading: true,
      showPaymentSelect: false,
      showTipPage: false,
      showCommentPage: false,
      showReviewPage: false,
      showCompletePage: false,
      tipAmount: 0,
      tipPercentage: [15, 10, 5],
      paypalButtonRendered: false,
      restaurantName: "",
      imageCahce: []
    };
  },
  computed: {
    groupOrderList: function () {
      return groupBy(this.orderList, "sourceMark");
    },
    ...mapStores(useUserStore, usePaymentStore, useCartStore),
    orderList: function () {
      return this.orderedDish.list?.length > 0 ? this.orderedDish.list.map(it => {
        it.cloudImage = this.imageCahce[it.dishesId]?.imagePath
        return it
      }) : [];
    },
    totalPriceOrderedDish: function () {
      return this.orderList.length > 0 ? this.orderedDish.total() : 0;
    },
    paymentMethodWithoutPayPal: function () {
      return this.paymentStore.paymentMethods.filter(p => !p.name.toLowerCase().includes('paypal'));
    },
    paypalPaymentMethod: function () {
      return this.paymentStore.paymentMethods.find(p => p.name.toLowerCase().includes('paypal'));
    },
    paypalCredentials: function () {
      const paypal = this.paypalPaymentMethod;
      return paypal ? {
        sandbox: 'AbBmj6XYaYu5X42wLdIrUMYmBUWTknOO3ikhMA_OihWFBJe-D4g-AGEG-kho6ASwvEv4bNIF57XC1TeR',
        production: paypal.apiKey
      } : null;
    },
    paypalApiKey: function () {
      return this.paypalCredentials?.production;
    }
  },
  methods: {
    async reloadOrderInfo() {
      this.orderInfo = (await getOrderInfo(Remember.orderId)).billInfo;
      if (this.orderInfo.consumeTypeStatusId > 4) {
        const orderInfo = {
          orderNumber: rotateDailySerial(this.orderInfo.dailySerial) || this.orderInfo.tableName.toLowerCase().replace("w", ""),
          orderAmount: this.orderInfo.totalPrice ?? 0,
          timestamp: Date.now()
        };
        localStorage.setItem("paypalOrderInfo", JSON.stringify(orderInfo));
        // Stop auto polling before navigating to order number page
        if (this._orderInfoTimer) {
          clearInterval(this._orderInfoTimer);
          this._orderInfoTimer = null;
        }
        router.push("/order-number");
      }
    },
    async renderPayPalButton() {
      if (this.paypalButtonRendered || !this.paypalApiKey) return;

      try {
        // Find the PayPal button container
        const buttonContainer = this.$refs.paypalButtonContainer;
        if (!buttonContainer) return;

        // Clear any existing content
        buttonContainer.innerHTML = '';

        // Load PayPal SDK
        const paypal = await loadScript({
          "client-id": this.paypalApiKey,
          currency: "EUR",
          components: "buttons,funding-eligibility",
          "enable-funding": "ideal"
        });

        // Capture the restaurant name, total price, and component instance in local variables
        const restaurantName = this.restaurantName;
        const totalPrice = this.totalPriceOrderedDish.toFixed(2);
        const self = this;

        // Render PayPal button
        await paypal.Buttons({
          style: {
            label: 'pay'
          },
          createOrder(data, actions) {
            return actions.order.create({
              intent: 'CAPTURE',
              application_context: {
                brand_name: restaurantName,
                shipping_preference: 'NO_SHIPPING',
              },
              purchase_units: [{
                amount: {
                  value: totalPrice,
                  currency_code: 'EUR'
                }
              }]
            });
          },
          async onApprove(data, actions) {
            const orderId = data.orderID;
            const paymentId = data.paymentID;
            const res = await actions.order.capture();

            if (res.status === "COMPLETED" || res.status === "APPROVED") {
              self.handlePayPalSuccess({
                orderId,
                paymentId,
                ...res
              });
            } else {
              alert("Payment Failed");
            }
          }
        }).render(buttonContainer);

        this.paypalButtonRendered = true;
      } catch (e) {
        console.warn("PayPal button rendering failed:", e);
      }
    },

    async handlePayPalSuccess(paypalData) {
      console.log("PayPal payment successful:", paypalData);

      // Get the necessary parameters
      const amount = this.totalPriceOrderedDish;
      const payMethodId = this.paypalPaymentMethod?.id ?? 9
      const tableId = this.orderInfo?.tableId;

      if (this._orderInfoTimer) {
        clearInterval(this._orderInfoTimer);
        this._orderInfoTimer = null;
      }

      // Call notifyCheckout
      await notifyCheckout(amount, payMethodId, tableId);

      // Store order information in localStorage
      const orderInfo = {
        orderNumber: this.orderInfo.dailySerial || this.orderInfo.tableName.toLowerCase().replace("w", ""),
        orderAmount: amount,
        timestamp: Date.now()
      };
      localStorage.setItem("paypalOrderInfo", JSON.stringify(orderInfo));

      // Update UI and redirect to the order number page
      this.showFastFoodPaymentPage = false;
      this.$router.push('/order-number');
    },

    async payByMethod(id) {
      console.log(id);
      // For non-fast food mode, use requireCheckOut
      await requireCheckOut();
      await this.cartStore.clearGlobalCart();
      // Update UI
      this.showPaymentSelect = false;
      this.showCompletePage = true;
    },
    submitComment() {
      this.showCommentPage = false;
      this.showPaymentSelect = true;
    },
    notUseEBon() {
      this.checkEmail = false;
      this.showPaymentSelect = true;
      this.showReviewPage = false;
    },
    async checkOrderInfo() {
      let res = null;
      try {
        res = JSON.parse(localStorage.getItem("userOrder"));
      } catch (e) {
        console.error("Error parsing userOrder from localStorage:", e);
      }
      this.email = res?.email ?? "";
      if (res?.orderUuid !== this.orderInfo?.electronicUuid || !res) {
        this.checkEmail = true;
      } else {
        this.notUseEBon();
      }
    },
    async sendEmail() {
      this.btnLoading = true;
      const id = this.orderInfo?.electronicUuid;
      const userOrder = {
        orderUuid: id,
        email: this.email
      };
      localStorage.setItem("userOrder", JSON.stringify(userOrder));
      await sendMailTo(this.email, id);
      this.btnLoading = false;
      this.notUseEBon();
    },
    submitTip(tipPercentage) {
      this.tipAmount = this.totalPriceOrderedDish * 0.01 * tipPercentage;
      this.showTipPage = false;
      this.showPaymentSelect = true;
    }
  },
  watch: {
    showFastFoodPaymentPage: function (val) {
      if (val && this.paypalApiKey) {
        // Wait for the DOM to update
        this.$nextTick(() => {
          this.renderPayPalButton();
        });
      } else {
        // Reset the flag when the sheet is closed
        this.paypalButtonRendered = false;
      }
    }
  },
  beforeDestroy() {
    if (this._orderInfoTimer) {
      clearInterval(this._orderInfoTimer);
      this._orderInfoTimer = null;
    }
  },
  async mounted() {
    this.loading = true;
    this.showCheckoutButton = await forceGetSystemSetting({
      section: "qrApp",
      sKey: "showCheckOutButton",
      sValue: "1",
      defaultValue: "1",
      sType: "boolean",
      minimumVersion: "1.7.784",
      sOptions: "",
      tagList: "basic"
    });
    this.imageCahce = keyBy(await getImageCache(), "dishesId")
    if (this.fastFoodMode) {
      const orderStatus = await getOrderStatus();
      if (orderStatus?.billInfo && orderStatus?.billInfo?.consumeTypeStatusId < 5) {
        setTableName(orderStatus.billInfo.tableName);
        this.orderInfo = orderStatus.billInfo;
      } else {
        router.replace("/menu");
        return;
      }
    } else {
      this.orderInfo = (await getCurrentInfo())?.order;
      if (!this.orderInfo) {
        router.replace("/menu");
        return;
      }
    }
    const dishes = await dishesInTable();
    this.orderedDish.clear();
    this.orderedDish.loadTTDishList(dishes);
    this.EBonStatus = await checkElectronicBillingStatus();

    // Get restaurant info
    try {
      const restaurantInfo = await getCurrentRestaurantInfo();
      this.restaurantName = restaurantInfo.name || 'Aaden POS';
    } catch (e) {
      console.warn("Failed to get restaurant name:", e);
      this.restaurantName = 'Aaden POS';
    }

    this.loading = false;

    // Auto refresh order info every 5 seconds
    if (this._orderInfoTimer) {
      clearInterval(this._orderInfoTimer);
    }
    this._orderInfoTimer = setInterval(() => {
      try {
        this.reloadOrderInfo();
      } catch (e) {
        console.warn('reloadOrderInfo interval error:', e);
      }
    }, 5000);
  }
};
</script>

<style scoped>

</style>
